import {Redirect, Route, Switch} from 'react-router-dom';
import Urls from '../../constants/urls';
import MSScene from './MSScene';
import {
  macHotspots,
  pianoHotspots,
  recordingHotspots,
  shelvesHotspots,
  tshirtHotspots,
  keyboardHotspots
} from './data';

const MSRooms = () => {
  return (
    <Switch>
      <Route
        {...Urls.musicStudio.root}
        render={() => <Redirect to={Urls.musicStudio.mac.path} />}
      />
      <Route {...Urls.musicStudio.mac}>
        <MSScene
          id="ms-mac"
          yRotation={360}
          hotspots={macHotspots}
        />
      </Route>
      <Route {...Urls.musicStudio.piano}>
        <MSScene
          id="ms-piano"
          yRotation={360}
          hotspots={pianoHotspots}
        />
      </Route>
      <Route {...Urls.musicStudio.recording}>
        <MSScene
          id="ms-recording"
          yRotation={360}
          hotspots={recordingHotspots}
        />
      </Route>
      <Route {...Urls.musicStudio.shelves}>
        <MSScene
          id="ms-shelves"
          yRotation={360}
          hotspots={shelvesHotspots}
        />
      </Route>
      <Route {...Urls.musicStudio.tshirt}>
        <MSScene
          id="ms-tshirt"
          yRotation={360}
          hotspots={tshirtHotspots}
        />
      </Route>
      <Route {...Urls.musicStudio.keyboard}>
        <MSScene
          id="ms-keyboard"
          yRotation={360}
          hotspots={keyboardHotspots}
        />
      </Route>
    </Switch>
  );
};

export default MSRooms;
